import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider as JotaiProvider } from 'jotai';
import { MantineProvider, createTheme } from '@mantine/core';
import { ModalsProvider } from '@mantine/modals';
import { Notifications } from '@mantine/notifications';
import NotificationsController from './components/providers/NotificationsController';
import '@mantine/core/styles.css';
import '@mantine/notifications/styles.css';
import App from './App';
import { installSafeAreaWatcher } from './utils/safeArea';
import { initializeStorage } from './storage';
import './styles/global.css';
async function initializeApp() {
    // 初始化存储系统及数据完整性检查
    await initializeStorage();
}
async function renderApp() {
    const container = document.getElementById('root');
    if (!container)
        throw new Error('Root container not found');
    const root = createRoot(container);
    try {
        // 标记 React 已接管根节点，避免全局 onerror 覆盖 DOM
        window.__APP_MOUNTED__ = true;
        await initializeApp();
        // 计算并注入 safe-area 变量（在 iOS 模拟器/部分容器中 env 可能返回 0）
        try {
            installSafeAreaWatcher();
        }
        catch { }
        const theme = createTheme({
            primaryColor: 'blue',
            defaultRadius: 'md',
            fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
        });
        root.render(_jsx(React.StrictMode, { children: _jsx(JotaiProvider, { children: _jsx(MantineProvider, { theme: theme, defaultColorScheme: "dark", children: _jsxs(ModalsProvider, { children: [_jsx(App, {}), _jsx(Notifications, { position: "top-center", zIndex: 10000, className: "app-notifications" }), _jsx(NotificationsController, {})] }) }) }) }));
    }
    catch (error) {
        // 渲染启动错误页面，便于排查
        root.render(_jsxs("div", { className: "error-boundary", style: { padding: 24 }, children: [_jsx("h2", { children: "Failed to start application" }), _jsx("p", { children: error instanceof Error ? error.message : 'Unknown error occurred' }), _jsx("button", { onClick: () => window.location.reload(), children: "Try Again" })] }));
    }
}
renderApp().catch((e) => console.error('Failed to start app:', e));
